package dev.lingvo.shared

private const val MAX_SLUG_LENGTH = 64
private const val MAX_EMAIL_LENGTH = 254
private const val MAX_EMAIL_LOCAL_PART_LENGTH = 64
private const val MAX_KEY_NAME_LENGTH = 255

private val slugRegex = Regex("^[a-z0-9]+(?:-[a-z0-9]+)*${'$'}")
private val emailRegex = Regex(
    """^[A-Za-z0-9.!#${'$'}%&'*+/=?^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?)+${'$'}""",
)
private val keyNameRegex = Regex("^[A-Za-z0-9][A-Za-z0-9._-]*${'$'}")
private val localeRegex = Regex(
    """^[A-Za-z]{2,3}(?:-[A-Za-z]{4})?(?:-(?:[A-Za-z]{2}|[0-9]{3}))?(?:-[A-Za-z0-9]{4,8})*${'$'}""",
)

fun validateSlug(slug: String): String? = when {
    slug.isBlank() -> "Slug is required."
    slug.length > MAX_SLUG_LENGTH -> "Slug must be $MAX_SLUG_LENGTH characters or fewer."
    !slugRegex.matches(slug) -> "Slug must contain only lowercase letters, numbers, and single hyphens."
    else -> null
}

fun validateEmail(email: String): String? {
    if (email.isBlank()) {
        return "Email is required."
    }
    if (email.length > MAX_EMAIL_LENGTH) {
        return "Email must be $MAX_EMAIL_LENGTH characters or fewer."
    }
    val localPart = email.substringBefore('@', missingDelimiterValue = "")
    if (
        localPart.length > MAX_EMAIL_LOCAL_PART_LENGTH ||
        localPart.startsWith('.') ||
        localPart.endsWith('.') ||
        ".." in localPart ||
        !emailRegex.matches(email)
    ) {
        return "Enter a valid email address."
    }
    return null
}

fun validateKeyName(name: String): String? = when {
    name.isBlank() -> "Key name is required."
    name.length > MAX_KEY_NAME_LENGTH -> "Key name must be $MAX_KEY_NAME_LENGTH characters or fewer."
    !keyNameRegex.matches(name) -> "Key name may contain only letters, numbers, dots, underscores, and hyphens."
    else -> null
}

fun validateLocale(locale: String): String? = when {
    locale.isBlank() -> "Locale is required."
    !localeRegex.matches(locale) -> "Enter a valid BCP-47 locale using hyphens."
    else -> null
}
